export enum ActionButtonEnum {
  REFRESH,
  SAVE_PDF,
  SAVE_CSV,
}
